import RequestProcessMethodContainer from './RequestProcessMethodContainer';

export default RequestProcessMethodContainer;
